var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.99997C16 3.58169 12.4183 0 8 0C3.5817 0 0 3.58169 0 7.99997C0 12.4183 3.5817 16 8 16C12.4183 16 16 12.4182 16 7.99997ZM1 7.99997C1 4.14016 4.14018 1 8 1C11.8598 1 15 4.14016 15 7.99997C15 11.8598 11.8598 15 8 15C4.14018 15 1 11.8598 1 7.99997ZM7 7C7 6.44772 7.44772 6 8 6C8.55229 6 9 6.44772 9 7V12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12V7ZM9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5C8.55229 5 9 4.55228 9 4Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.114e8be0395cd764f00705f16d531d2b.svg";
export { ForwardRef as ReactComponent };